export default __webpack_public_path__ + "static/media/bottom.6f9f6d11.jpg";